import { Link } from "react-router-dom";

/**
 * AuthShell — shared layout for /signin, /signup, /verify-email,
 * /forgot-password, /reset-password. Keeps the brand visuals consistent
 * and reduces duplication across the auth pages.
 */
export default function AuthShell({ title, subtitle, children, footer }) {
  return (
    <div className="min-h-screen bg-[#0B0B0B] flex items-center justify-center px-6 relative overflow-hidden">
      <div className="absolute inset-0 radial-gold-glow opacity-60" />
      <div className="absolute inset-0 noise-overlay" />

      <div className="relative w-full max-w-md glass-panel rounded-3xl p-7 sm:p-9">
        <Link
          to="/"
          data-testid="auth-back-home"
          className="text-xs text-white/40 hover:text-white/80 transition inline-flex items-center gap-1.5 mb-6"
        >
          ← Back to home
        </Link>
        <div className="flex items-center gap-2.5 mb-7">
          <div className="w-9 h-9 rounded-lg bg-gradient-to-br from-[#F3CE5A] to-[#8B6914] flex items-center justify-center shadow-[0_0_24px_rgba(212,175,55,0.35)]">
            <span className="font-display text-black text-base font-bold">F</span>
          </div>
          <span className="font-display text-2xl text-white tracking-tight">Facetra · Studio</span>
        </div>

        <h1 className="font-display text-3xl md:text-4xl text-white tracking-tight">{title}</h1>
        {subtitle && (
          <p className="mt-3 text-sm text-white/60 leading-relaxed">{subtitle}</p>
        )}

        {children}

        {footer && (
          <div className="mt-7 pt-5 border-t border-white/8 text-center text-xs text-white/50">
            {footer}
          </div>
        )}
      </div>
    </div>
  );
}
